<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isThanksVisible"
      v-bind="thanks"
      slot="middle"
    />
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
  </BaseScreen>
</template>

<script>
import { mapState } from 'vuex';

import screenMixin from '@/mixins/screen';
import mailMixin from '@/mixins/mail';

export default {
  name: 'AudioSendScreen',
  mixins: [screenMixin, mailMixin],
  components: {},
  computed: {
    ...mapState('feedback', [
      'audio',
    ]),
    titleText() {
      return this.$t('feedback.contactsTitle');
    },
    screenCase() {
      if (this.isThanksVisible) {
        return 'STEP_FEEDBACK_SENDED';
      }
      if (this.isErrorVisible) {
        return 'STEP_SENDING_ERROR';
      }
      return 'STEP_SEND_AUDIO';
    },
    thanks() {
      return {
        icon: {
          name: 'heart',
          theme: 'thanks',
          size: 'l',
        },
        title: {
          text: this.$t('feedback.thanks'),
          size: 'l',
        },
        description: {
          text: this.$t('feedback.respect'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('feedback.goHome'),
            action: this.goToHomeScreen,
          },
        ],
      };
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'error',
          view: 'circle',
          size: 'l',
        },
        title: {
          text: this.$t('feedback.badHardware'),
          size: 'l',
        },
        description: {
          text: this.$t('feedback.notPossible'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('feedback.goHome'),
            action: this.goToHomeScreen,
          },
        ],
      };
    },
  },
  created() {
    this.showPending(0);
    this.sendFeedbackToMail();
  },
  methods: {
    sendFeedbackToMail() {
      const email = process.env.VUE_APP_FEEDBACK_EMAIL;
      const subject = this.$t('feedback.emailSubject');
      const file = this.audio?.fullpath;
      const body = [
        [this.$t('feedback.emailDateLabel'), new Date().toISOString()],
      ]
        .map((el) => el.join(': '))
        .join('\n');

      return this.sendMail(email, subject, body, file); // функция из миксина
    },
  },
};
</script>
